import React, { FC } from "react";

interface SearchInputFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const SearchInputFeild: FC<SearchInputFieldProps> = ({
  value,
  onChange,
  placeholder = "Search", // Default placeholder
}) => {
  return (
    <div className="form-group h-100 has-search d-flex align-items-start">
      <div className="w-100 position-relative">
        <input type="hidden" />
        <i className="ki-duotone ki-magnifier fs-2 search-icon position-absolute top-50 translate-middle-y ms-4">
          <span className="path1" />
          <span className="path2" />
        </i>
        <input
          type="text"
          className="search-input bg-transparent form-control form-control-sm ps-12 fs-6 h-100"
          name="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          data-kt-search-element="input"
        />
      </div>
    </div>
  );
};

export default SearchInputFeild;
